module.exports = __webpack_public_path__ + "img/icon-privacy-gray.e165d925.svg";